import api from "./apiConfig";


export const getAllUsers = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const usersCall = await api.get('/users', { params: data, headers: { 'x-auth-token': localStorage.getItem('token') } })
            let status = usersCall?.data?.status;
            let successData = usersCall?.data?.data;
            let message = usersCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            resolve([{ message: error, status: 500 }, null])
        }
    })
}

export const createUsers = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            // const usersCall = await api.post('/users', { ...data })//submitting every content of the data
            const usersCall = await api.post('/users', data, {
                headers: { 'x-auth-token': localStorage.getItem('token') }
            });

            let status = usersCall?.data?.status;
            let successData = usersCall?.data?.data;
            let message = usersCall?.data.message;

            if (status != 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            // send error back
            reject(error)
        }
    })
}

export const updateUser = async (userId, formData) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const response = await api.put(`/users/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'x-auth-token': localStorage.getItem('token')
                },
            });

            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error updating user:', error);
            resolve([{ message: error.message, status: error.response?.status || 500 }, null]);
        }
    });
};

export const deleteUser = async (userId) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const response = await api.delete(`/users/${userId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': localStorage.getItem('token')
                },
            });
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
            reject(error);

        }
    })
};


export const getTotalUsers = async () => {
    try {
        const response = await api.get(`/users/total`, {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        return response.data.message.total;
    } catch (error) {
        throw error;
    }
};

